import * as React from "react"
import classNames from "classnames"

import useTransientAnimation from "@/lib/useTransientAnimation"

import * as styles from "./CodeBlock.css"

type CodeBlockProps = {
	code: string
	flash?: boolean
	flashId?: unknown
	viewTransitions?: "default" | "none"
}
export default function CodeBlock({
	code,
	flash = false,
	flashId = undefined,
	viewTransitions = "default",
}: CodeBlockProps) {
	const codeBlockRef = useTransientAnimation<HTMLDivElement>({
		className: styles.codeBlockFlashAnimation,
		isEnabled: flash,
		animId: flashId,
	})

	return (
		<div
			ref={codeBlockRef}
			className={classNames(styles.codeBlock({ viewTransitions }))}
		>
			<code className={styles.code}>
				<pre className={styles.codeContent}>{code}</pre>
			</code>
		</div>
	)
}
